<form #form="ngForm" novalidate>
    <div class="card  mb-3">
        <div class="card-header">
            <h6 class="card-title mb-0">E-mails Administrativos</h6>
            <small class="card-subtitle mb-0">E-mails administrativos são e-mails que podem ser cadastrados para aparecerem como sugestão para selecionar no envio de e-mails</small>
        </div>
        <div class="table-responsive">
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th class="col-options"></th>
                        <th class="col-email">E-mail</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let entity of entities; let i = index">
                        <td class="col-options">
                            <a (click)="delete(i)">
                                <i class="far fa-trash-alt" aria-hidden="true"></i>
                            </a>
                        </td>
                        <td class="col-email">
                            <input type="email" class="form-control" [(ngModel)]="entity.email" name="contatoEmail_{{i}}" id="contatoEmail_{{i}}"
                                #emailAdministrativo="ngModel" maxlength="255" sgtLowercase [autofocus]="true">
                        </td>
                    </tr>
                    <tr *ngIf="entities.length === 0" class="no-record">
                        <td class="text-center" colspan="2">
                            <i class='fas fa-info' aria-hidden='true'></i> Nenhum registro encontrado
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="card-footer p-2">
            <button type="button" class="btn btn-primary btn-sm" (click)="insert()">
                <i class="fas fa-plus" aria-hidden="true"></i> Adicionar E-mail
            </button>
        </div>
    </div>
</form>

